import { render, staticRenderFns } from "./ConfirmUser.vue?vue&type=template&id=587c27a8"
import script from "./ConfirmUser.vue?vue&type=script&lang=js"
export * from "./ConfirmUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports